
export class TicketMeta
{
    public CreatedAt = new Date(0);
    public CreatedBy: string = "";
}
